import { useState, useRef } from "react";
import gsap from "gsap";
import Nav from "./general/Nav";
import Home from "./pages/Home";
import NavTop from "./general/NavTop";
import PortfolioView from "./pages/PortfolioView";

function App() {
  const [view, setView] = useState("home");
  const [portfolioindex, setPortfolioindex] = useState("0");
  const leftCurtain = useRef(null);
  const rightCurtain = useRef(null);

  const changeView = (newView) => {
    if (newView === view) return; // Prevent unnecessary animations

    // Step 1: Close the curtains by animating their width to 50%
    gsap.to([leftCurtain.current, rightCurtain.current], {
      width: "50%", // Animate both curtains to cover half the screen
      duration: 0.7,
      ease: "power2.in",
      onComplete: () => {
        // Step 2: Change the content behind the curtains
        setView(newView);

        // Step 3: Scroll to top
        window.scrollTo({ top: 0, behavior: "instant" });

        // Step 4: Wait for 50ms to allow the new content to load
        setTimeout(() => {
          // Step 5: Open the curtains by animating their width back to 0%
          gsap.to(leftCurtain.current, {
            width: "0%", // Animate the left curtain back to 0% width
            duration: 0.7,
            ease: "power2.out",
          });
          gsap.to(rightCurtain.current, {
            width: "0%", // Animate the right curtain back to 0% width
            duration: 0.7,
            ease: "power2.out",
          });
        }, 300); // 50ms delay
      },
    });
  };

  return (
    <div className="App flex flex-col relative bg-black">
      {/* Navigation */}
      <Nav pageOn={view} setView={changeView} />
      <NavTop />

      {/* Page Content */}
      <div className="relative flex-1 w-full">
        {view === "home" && (
          <Home setPortfolioindex={setPortfolioindex} setView={changeView} />
        )}
        {view === "portfolio" && (
          <PortfolioView indexOf={portfolioindex} setView={changeView} />
        )}
      </div>

      {/* Curtain Effect */}
      <div
        ref={leftCurtain}
        className="fixed top-0 left-0 w-0 h-full bg-[#0a0a0d] z-[50]"
      ></div>
      <div
        ref={rightCurtain}
        className="fixed top-0 right-0 w-0 h-full bg-[#0a0a0d] z-[50]"
      ></div>
    </div>
  );
}

export default App;
